import { Box, SxProps } from '@mui/material';
import { usePracticePayers } from 'apps/wrapper/src/hooks/use-practice-payers';
import moment from 'moment';
import { FC, useMemo } from 'react';
import { useApptRequestIvStatusDialog } from '../../hooks/use-appt-request-iv-status-dialog/hook';

export interface IvInfoProps {
  undefinedAsBold?: boolean;
  sx?: SxProps;
}
const getDobDisplay = (rawDob?: string | null): string | undefined => {
  if (!rawDob) return undefined;
  const m = moment(rawDob);
  const oldestAllowed = moment().subtract(130, 'years');
  const now = moment();
  if (!m.isValid() || m.isAfter(now) || m.isBefore(oldestAllowed)) return undefined;
  return m.format('MMMM DD, YYYY');
};

export const IvInfo: FC<IvInfoProps> = (props) => {
  const { undefinedAsBold, sx } = props;
  const { appointmentRequest, ivSummary } = useApptRequestIvStatusDialog();
  const { getPayerNameById } = usePracticePayers();

  const subscriberFullName = useMemo(() => {
    const first = appointmentRequest?.insuranceInfo?.subscriberFirstName;
    const last = appointmentRequest?.insuranceInfo?.subscriberLastName;
    if (first && last) return `${first} ${last}`;
    return first || last || undefined;
  }, [appointmentRequest]);

  const ivDataItem = (key: string, value?: any) => {
    const keyElement = <Box sx={{ fontWeight: undefinedAsBold && value ? 400 : 500 }}>{key}:</Box>;
    const val = !value ? (undefinedAsBold ? '<unknown>' : 'Unknown') : value;
    const valueElement = <Box sx={{ fontWeight: undefinedAsBold && !value ? 500 : 400 }}>{val}</Box>;

    return (
      <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', margin: '4px 0' }}>
        {keyElement}&nbsp;{valueElement}
      </Box>
    );
  };

  return (
    <Box sx={sx ? sx : { marginTop: '10px' }}>
      {ivDataItem('Date of Birth', getDobDisplay(appointmentRequest?.insuranceInfo?.subscriberDateOfBirth))}
      {ivDataItem('Insurance', ivSummary?.idPayer || (appointmentRequest?.insuranceInfo?.carrier && getPayerNameById(appointmentRequest.insuranceInfo.carrier)) || appointmentRequest?.insuranceInfo?.carrier)}
      {ivDataItem('Member ID', appointmentRequest?.insuranceInfo?.memberId)}
      {ivDataItem('Subscriber Name', subscriberFullName)}
    </Box>
  );
};
